/**
 * Detect tenant slug from current hostname.
 * Used by both TenantContext and constants.
 */
export function getTenantSlugFromHostname(): string {
  if (typeof window === 'undefined') {
    return 'sharewares'; // SSR fallback
  }

  const hostname = window.location.hostname;
  const mapping: Record<string, string> = {
    'orders.sharewares.ca': 'sharewares',
    'alpha.sharewares.ca': 'alphaselect',
    'localhost': 'sharewares',
    '127.0.0.1': 'sharewares',
  };

  return mapping[hostname] || process.env.REACT_APP_TENANT_SLUG || 'sharewares';
}
